<div class="container">
    <form [formGroup]="replyForm" (ngSubmit)="submitReplyDocumentForm()">
        <mat-toolbar style="gap:0.5rem">
            <button type="button" mat-icon-button matTooltip="Atrás" aria-label="Atrás" (click)="onBack()">
                <mat-icon>
                    <span class="material-symbols-outlined">
                        arrow_back
                    </span>
                </mat-icon>
            </button>
            <button mat-stroked-button type="submit" (click)="isPreview=true"
                [disabled]="!replyForm.valid || fetchingReplyDocument">
                <div class="btn-login-content">
                    @if (fetchingReplyDocument && isPreview) {
                    <mat-spinner diameter="20" color="warn"></mat-spinner>
                    }@else{
                    <p>Vista previa</p>
                    }
                </div>
            </button>
            <button class="update-button" type="submit" [disabled]="!replyForm.valid || fetchingReplyDocument"
                mat-flat-button>
                <div class="btn-login-content">
                    @if (fetchingReplyDocument && !isPreview) {
                    <mat-spinner diameter="20" color="warn"></mat-spinner>
                    }@else{
                    <p>Aceptar</p>
                    }
                </div>
            </button>
            <button type="button" mat-stroked-button (click)="onBack()">Cancelar</button>

        </mat-toolbar>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="Informaci&oacute;n del documento" style="overflow: hidden;">
                <div>
                <fieldset class="mat-mdc-card sgd-card " style="padding-top: 0; margin: 15px;">
                    <legend>&nbsp;</legend>
                    <br>
                    <button mat-flat-button color="accent" type="button" (click)="openDlgDestino()"
                        style="position: absolute; top: -28px;">
                        <mat-icon>person_search</mat-icon> Buscar participantes
                    </button>
                    <mat-card class="sgd-card" style="border: 0; margin-top: 0px; margin: 0px;">
                        <div class="participantes-container">
                            <mat-card-subtitle>
                                De: &nbsp;
                                @for (participante of participantes.origen; track $index) {
                                <div class="participante-label">
                                    <mat-icon>account_circle</mat-icon>
                                    <span>
                                        {{participante.nombres | capitalize}}
                                    </span>
                                </div>
                                }
                            </mat-card-subtitle>
                            <mat-card-subtitle>
                                Para:
                                @if (replyForm.controls.participantes.hasError('requiredDestino')) {
                                <mat-error class="participante-label">Elegir al menos un destinatario!</mat-error>
                                }
                                @for (participante of participantes.destinoBuzon; track $index) {
                                <div class="participante-label">
                                <mat-icon>person</mat-icon>
                                <span>
                                    {{participante.cargo}}
                                </span>
                                </div>
                                }
                                @for (participante of participantes.destino; track $index) {
                                <div class="participante-label">
                                    <mat-icon>person</mat-icon>
                                    <span>
                                        {{participante.nombres | capitalize}}
                                    </span>
                                </div>
                                }
                            </mat-card-subtitle>
                        </div>
                    </mat-card>
                </fieldset>
                <div class="row" style="margin: 0;">
                    <div class="col-7 col-lg-7 tight-column">
                        <mat-form-field class="full-width">
                            <mat-label>Tipo documento</mat-label>
                            <mat-select (selectionChange)="manageChangedDocumentType($event)"
                                [(value)]="defaultDocumentType" formControlName="documentType">
                                @for (documentType of documentTypes; track $index) {
                                <mat-option value={{documentType.id}}>{{documentType.descripcion}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-5 col-lg-5 tight-column">
                        <mat-form-field class="full-width">
                            <mat-label>Categor&iacute;a</mat-label>
                            <mat-select formControlName="category">
                                <mat-option value="0">Extemporaneo</mat-option>
                                <mat-option value="1">Normal</mat-option>
                                <mat-option value="2">Personal</mat-option>
                                <mat-option value="3">Urgente</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-7 tight-column">
                        <mat-form-field class="full-width">
                            <mat-label>N&uacute;mero de Documento</mat-label>
                            <!--<mat-icon matPrefix class="material-symbols-outlined numeracion-field"
                                matTooltip="Los s&iacute;mbolos #### representa el n&uacute;mero que se generar&aacute; al guardar el documento">help</mat-icon>
                            <button type="button" mat-icon-button matSuffix class="numeracion-field"
                                matTooltip="Editar n&uacute;mero" (click)="onEditConfirm()">
                                <mat-icon>edit</mat-icon>
                            </button>-->
                            <input matInput formControlName="numeracion" #numeracionInput
                                [readonly]="readOnlyNumeracion" maxlength="100" />
                            <button type="button" mat-icon-button matSuffix class="numeracion-field"
                                (click)="onDlgNumeracion()">
                                <mat-icon>list</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-5 tight-column"
                        style="display: flex;justify-content: space-between;align-items: center;">
                        <mat-form-field class="full-width">
                            <mat-label>N&uacute;mero de referencia</mat-label>
                            <input matInput formControlName="numeroReferencia" readonly />
                            <button type="button" mat-icon-button matSuffix matTooltip="Ver oficio"
                                (click)="openAnexo(getAnexoOficio()!)">
                                <mat-icon>picture_as_pdf</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-7 tight-column d-flex align-items-center">
                        <mat-form-field class="full-width small-form-field" style="flex: 1">
                            <mat-label>Asunto</mat-label>
                            <input matInput formControlName="asunto" type="text" />
                            @if (replyForm.controls.asunto.getError('maxlength')) {
                            <mat-error class="participante-label">Longitud máxima de 250 caracteres</mat-error>
                            }
                        </mat-form-field>
                            @if (editor() == EditorType.odt) {
                            <button mat-icon-button class="fullscreen-button" [class.active]="editorHasFocus || fullscreenActive" [color]="(editorHasFocus || fullscreenActive) ? 'primary' : ''" aria-label="Pantalla completa" type="button" [disabled]="!(editorHasFocus || fullscreenActive)" [matTooltip]="(editorHasFocus || fullscreenActive) ? 'Pantalla completa' : 'Seleccione el documento'" (click)="onFullscreen()">
                                <mat-icon>fullscreen</mat-icon>
                            </button>
                            }
                    </div>
                    <div class="col-12 col-lg-5 tight-column">
                        <mat-form-field class="full-width">
                            <mat-label>Tipificaci&oacute;n</mat-label>
                            <mat-select formControlName="tipificacion">
                                <mat-option value="0">Sin tipificaci&oacute;n</mat-option>
                                <mat-option value="1">Solicitud informaci&oacute;n p&uacute;blica</mat-option>
                                <mat-option value="2">Confidencial</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                @if (editor() == EditorType.html) {
                <ngx-suneditor [options]="editorOptions" (onChange)="manageEditorContentChange($event)">ddd</ngx-suneditor>
                }

                @if (editor() == EditorType.odt) {
                @if (!collaboraUrl) {
                <div style="display: flex; align-items: center; justify-content: center; height: 60vh; flex-direction: column;">
                <mat-spinner diameter="50"></mat-spinner>
                <p style="margin-top: 1rem;">Inicializando editor...</p>
                </div>
                }@else{
                <app-collabora-editor #collaboraEditorComponent [editorUrl]="collaboraUrl" [fileName]="'documento.odt'"
                [fileExtension]="'odt'" [readOnly]="false" (editorReady)="onCollaboraReady()"
                (contentChanged)="onCollaboraContentChanged()" (error)="onCollaboraError($event)"
                (focusChange)="onEditorFocus($event)"
                style="display: block; width: 100%; min-height: 500px;">
                </app-collabora-editor>
                }
                }
            </div>
            </mat-tab>
            <mat-tab label="Anexos">                
                <app-anexos-full [anexos]="anexos" [idTarea]="documentID" [isEdit]="true" [isAddAnexo]="true"
                    [hasParticipated]="hasParticipated" [isOwner]="isOwner" [isScope]="alcanceMode" 
                    [estadoTarea]="estadoTarea"></app-anexos-full>
            </mat-tab>
        </mat-tab-group>
    </form>
</div>